/* CUSTOM: PUR-SUIT recently viewed. Records each product view (by handle) in
   localStorage, then rebuilds cards from /products/{handle}.js for the strip on the
   product page. Renders BEFORE recording the current product so the current piece is
   excluded. Fails silent + stays hidden if there's nothing to show. Vanilla, no deps. */
(function () {
  "use strict";

  var KEY = "ps:recently-viewed";
  var CAP = 12;

  var sec = document.querySelector("[data-ps-rv]");
  if (!sec) return;

  var grid = sec.querySelector("[data-ps-rv-grid]");
  var current = sec.getAttribute("data-current-handle") || "";
  var currency = sec.getAttribute("data-currency") || "USD";
  var max = parseInt(sec.getAttribute("data-max") || "4", 10);
  var soldLabel = sec.getAttribute("data-sold-label") || "Sold";

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function sized(url, w) {
    if (!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  // Build from the list as it was BEFORE this visit, minus the current product.
  var toShow = read().filter(function (h) { return h && h !== current; }).slice(0, max);

  if (toShow.length) {
    Promise.all(
      toShow.map(function (h) {
        return fetch("/products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (items) {
      var frag = document.createDocumentFragment();
      var any = false;
      items.forEach(function (p) {
        if (!p || !p.handle) return;
        any = true;
        var img = p.featured_image || (p.images && p.images[0]) || "";
        var sold = p.available === false;
        var li = document.createElement("li");
        li.className = "ps-rv__item" + (sold ? " ps-rv__item--sold" : "");
        /* cards are 4:5 crops (CSS aspect-ratio); serve DPR-appropriate widths and
           declare dimensions so the browser never has to guess the box */
        var imgHtml = img
          ? '<span class="ps-rv__media"><img loading="lazy" decoding="async" width="500" height="625"' +
            ' src="' + esc(sized(img, 500)) + '"' +
            ' srcset="' + esc(sized(img, 300)) + ' 300w, ' + esc(sized(img, 500)) + ' 500w, ' + esc(sized(img, 700)) + ' 700w, ' + esc(sized(img, 900)) + ' 900w"' +
            ' sizes="(min-width: 750px) 25vw, 50vw"' +
            ' alt="' + esc(p.title) + '"></span>'
          : "";
        li.innerHTML =
          '<a class="ps-rv__card" href="' + esc(p.url || "/products/" + p.handle) + '">' +
          imgHtml +
          '<span class="ps-rv__name">' + esc(p.title) + "</span>" +
          (sold
            ? '<span class="ps-rv__sold">' + esc(soldLabel) + "</span>"
            : '<span class="ps-rv__price">' + esc(money(p.price)) + "</span>") +
          "</a>";
        frag.appendChild(li);
      });
      if (any && grid) {
        grid.appendChild(frag);
        sec.hidden = false;
      }
    });
  }

  // Record the current product for next time (unshift, dedupe, cap).
  if (current) {
    var next = [current].concat(read().filter(function (h) { return h !== current; })).slice(0, CAP);
    write(next);
  }
})();
